import { post, get } from './client';
import type { CheckoutSession, BillingPortal } from '@/types/api';

// §3 billing (Lemon Squeezy)
export const createCheckoutSession = () =>
  post<CheckoutSession>('/billing/checkout-session', {});

export const getBillingPortal = () => get<BillingPortal>('/billing/portal');

export const cancelSubscription = () =>
  post<{ canceled_at: string; current_period_end: string }>('/me/cancel-subscription');
